const autoNgTemplateLoaderTemplate1 = require('./kubernetes-sidebar.html');

import angular from 'angular';

angular.module('shbdeployer.kubernetes').component('kubernetesSidebar', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    endpointId: '<',
    isSidebarOpen: '<',
    adminAccess: '<',
  },
});
